import * as Net from './dotNet';
import * as UI from './uiGenerators';
import { updateEmployeeDashboardData } from '../../actions';
import { currentHttpOptions } from '../../../utils';

/**
 * Load shifts and paycodes, generate initial calendar schedule, and dispatch to store
 *
 * @param {Function} dispatch - Redux dispatch function
 * @param {Object} storeState - Current Redux store state
 * @returns {Promise<boolean>} - Returns true on success, false on failure
 */
export const loadShiftsAndPaycodes = async (dispatch, storeState) => {
    try {
        const { statusDictionary, data, dateRanges, managerSettings, globalConfigs, personName } = storeState;

        // Make parallel API calls for shifts and paycodes
        const [employeeShiftsResponse, employeePaycodesResponse] = await Promise.all([
            Net.getMyShifts(currentHttpOptions(), dateRanges.startDate, dateRanges.endDate),
            Net.getPaycodes(currentHttpOptions(), dateRanges.startDate, dateRanges.endDate)
        ]);

        // Generate initial monthly schedule
        let initialMonthlySchedule = UI.generateSchedule(
            true,
            employeeShiftsResponse.data.shifts,
            data.employeeShiftOffers || [],
            data.availableShiftsToCover || [],
            data.employeeShiftRequests || [],
            data.employeeMyShiftSwapOffers || [],
            data.availableShiftToSwapOffers || [],
            employeePaycodesResponse.data,
            data.myProposals || [],
            data.availableOpenShifts || [],
            data.myOpenShiftRequests || [],
            data.availableVTO || [],
            data.myVTORequests || [],
            statusDictionary,
            personName,
            managerSettings,
            dateRanges,
            globalConfigs.postedRequestDisplay,
        );

        // Prepare payload for Redux store
        let initialPayload = {
            monthlySchedule: initialMonthlySchedule,
            employeeShifts: employeeShiftsResponse.data.shifts,
            employeePaycodes: employeePaycodesResponse.data,
        };

        // Dispatch to store
        dispatch(updateEmployeeDashboardData(initialPayload));

        return true; // Success
    } catch (err) {
        console.log('Error loading shifts and paycodes:', err);
        return false; // Failure
    }
};

